/**
 * Authenticated fetch utility.
 * Reads the session token from localStorage and attaches it
 * as a Bearer token in the Authorization header.
 * Replaces the need for credentials: 'include' (which fails
 * when the ingress returns Access-Control-Allow-Origin: *).
 */
const API = process.env.REACT_APP_BACKEND_URL;

export function authFetch(url, options = {}) {
  const token = localStorage.getItem('swell_session_token');
  const headers = { ...options.headers };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  // Remove credentials: 'include' — we use Bearer tokens instead
  const { credentials, ...rest } = options;
  return fetch(url, { ...rest, headers });
}

export { API };
